<template>
    <chip-label :color="steps[step].hex" :label="steps[step].label" />
</template>

<script>
import ChipLabel from "vcomponents/utilities/ChipLabel.vue";
const expirationDuration = 604800 // one week

export default {
    props: {
        doctype: {
            require: true,
            type: String
        },
        step: {
            require: true,
            type: String
        }
    },
    data () {
        return {
            steps: {}
        }
    },
    created () {
        const objet = JSON.parse(localStorage.getItem(this.storageKey))

        if (objet === null) {
            this.fetchSteps()
        }

        if (objet !== null && objet.expire_at < new Date().getTime()) {
            this.fetchSteps()
        }

        this.steps = objet.value
    },
    methods: {
        fetchSteps () {
            window.SellsyJS.WebServiceCaller.get(`/rest/sales/${this.doctype}/steps`, {},
            (response) => {
                this.setSteps(response)
            }, (error) => {
                Push.error(this.$l10n.__("Une erreur est survenue, veuillez ré-essayer ultérieurement."))
            })
        },
        setSteps (steps) {
            const expiration = (new Date().getTime()) + expirationDuration
            const object = {
                expire_at: expiration,
                value: steps
            }
            localStorage.setItem(this.storageKey, JSON.stringify(object))
            this.steps = steps
        }
    },
    computed: {
        storageKey () {
            return `document_sale_${this.doctype}_step`
        }
    },
    components: {
        ChipLabel
    }
}
</script>